// Joins class names, dropping falsy parts. Kept tiny on purpose so no
// component pulls a class-name library for one line.
export function cx(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
